import { Instance } from 'mobx-state-tree';

import { RootModel, RootModelType } from './RootModel';
import { Persist } from './utils';
import { migrations } from './migrations/migrations';

interface ICreateRootModelResult {
  store: Instance<RootModelType>;
  createPersist: () => Promise<Persist<Instance<RootModelType>>>;
}

export function createRootModel(
  initialState = {},
): ICreateRootModelResult {
  const store = RootModel.create(initialState);

  return {
    store,
    createPersist: () => Persist.create(store, 'root', migrations),
  };
}
